
(function() {
  var wid = $WR.define('cheetahApplication/form/closeButton', [], function(require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'closeButton',
    designer: 'DesignerCloseButton'
  });
})();


(function() {
  var wid = $WR.define('cheetahApplication/form/DesignerCloseButton', [], function(require, exports, module) {
    var HTML = '';

    var Class = MW.extend(require('designer/form/default/Button'), {
      defaults: {
        xtype: 'closeButton',
        xtypeName: '关闭按钮',
        value: "关闭",
        actionName: "关闭",
        action: "formClose",
        sizeCls: "btn-std",
        iconCls: "fa fa-close",
        colorCls: "btn-primary"
      }
    });
    module.exports = Class;
  });
  $WR.defineType({
    id: wid,
    xtype: 'DesignerCloseButton',
    designer: ''
  });
})();





// WEBPACK FOOTER //
// ./src/common/formWidget/closeButton.js